// extracted by mini-css-extract-plugin
module.exports = {"content":"CompanyDetailHeader_content__3SfnT","sending":"CompanyDetailHeader_sending__1AeuX"};